import { render } from "./ContactCoach.vue?vue&type=template&id=73563190&scoped=true"
import script from "./ContactCoach.vue?vue&type=script&lang=js"
export * from "./ContactCoach.vue?vue&type=script&lang=js"

import "./ContactCoach.vue?vue&type=style&index=0&id=73563190&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73563190"

export default script